import { RoleName } from './role-name';

const hasRole = (user: { roles: { role: string | RoleName }[] }, role: RoleName | RoleName[]) => {
  const roles = Array.isArray(role) ? role : [role];
  return user.roles.some((r) => roles.includes(r.role as RoleName));
};

export { hasRole };
